import { render, staticRenderFns } from "./ConfigAggregation.vue?vue&type=template&id=52a80528"
import script from "./ConfigAggregation.vue?vue&type=script&lang=js"
export * from "./ConfigAggregation.vue?vue&type=script&lang=js"
import style0 from "./ConfigAggregation.vue?vue&type=style&index=0&id=52a80528&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports